import {
  type FinancialAccountTypeEnum,
  FinancialAccountTypes,
} from '../entities/enums/FinancialAccountTypeEnum'

export const useCurrencySymbol = ({
  financialAccountType,
}: {
  financialAccountType: FinancialAccountTypeEnum
}) => {
  switch (financialAccountType) {
    case FinancialAccountTypes.AIRWALLEX_GBP:
      return '£'
    default:
      return '$' // Defaults to dollar symbol
  }
}
